
























































import Vue from "vue";
import Component from "vue-class-component";
import IProcessOptionModel from "@/chipply/IProcessOptionModel";
import Validation from "@/chipply/Validation";
import { Utils } from "chipply-common";
import { Prop } from "vue-property-decorator";
import { PriceDisplayHelper } from "@/chipply/helper/PriceDisplayHelper";
import CartViewModel from "@/chipply/view-model/CartViewModel";
@Component({})
export default class ProductOptionDisplay extends Vue {
    public name = "ProductOptionDisplay";
    public Utils = Utils;

    @Prop({ type: Object })
    public option!: IProcessOptionModel;

    @Prop({ type: Object })
    public cartVm!: CartViewModel;

    private priceDisplayHelper = new PriceDisplayHelper();

    protected validateItem(option: IProcessOptionModel) {
        if (option.userValue && option.isRequired) {
            if (option.userValue != "") {
                return true;
            } else {
                return "Required option not filled";
            }
        } else if (option.isRequired && option.userValue == undefined) {
            return "Required option not filled";
        } else {
            return true;
        }
    }

    public get displayOptionPrice() {
        const optionPriceDisplay = Utils.getCurrencyValue(this.option.extraFee, true, true);
        if (!this.cartVm || !this.cartVm.branding) {
            return optionPriceDisplay;
        }
        const priceDisplay = {
            displayType: this.cartVm.branding.storePriceDisplayType,
            dollarValuePerPoint: this.cartVm.branding.storeDollarValuePerPoint ?? 0,
        };
        const prices = this.priceDisplayHelper.getPriceDisplay(this.option.extraFee, priceDisplay, optionPriceDisplay);
        const display = prices.join("");
        return display;
    }

    private mobileColLengths(priceLabel: boolean) {
        if (priceLabel) {
            if (!this.$vuetify.breakpoint.smAndUp) {
                return "6";
            } else {
                return "4";
            }
        } else {
            if (!this.$vuetify.breakpoint.smAndUp) {
                return "6";
            } else {
                return "8";
            }
        }
    }

    protected validateMaxLength(option: IProcessOptionModel) {
        if (option.maxCharacters === 0) {
            return true;
        } else {
            return Validation.requireMaximumLengthOf(option.maxCharacters)(option.userValue);
        }
    }
}
